<script lang="ts">
    import {link} from 'svelte-spa-router';
</script>
<i class="material-icons">
    info
</i>
<p>
    The page you are looking for has been removed or its name has been changed.  <a href="/" use:link>Back to Homepage</a>
</p>
    <style type="scss">
        @use "../scss/_variables.scss" as v;
i {
    padding-top:20vh;
    font-size:64pt;
    color: v.$primary-highlight;
    display: block;
    margin:0 auto;
}
p {
    text-align: center;
}
</style>